var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formats)?_c('div',[_vm._v("\n  TTS字符替换:\n  "),_vm._l((_vm.formats),function(fmt,idx){return _c('div',{key:idx},[_vm._v("\n    当发送内容为:"+_vm._s(fmt.match)+"    将:"+_vm._s(fmt.pattern)+"    替换为:"+_vm._s(fmt.replace)+"\n  ")])})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }